module.exports = __webpack_public_path__ + "img/foto 1.98b80cc0.jpg";